import { calculateCouponAmount } from '@debtSecurityUtils';

interface CouponDepositBond {
  isin: string;
  issue_number: string;
  coupon_rate: number;
  face_value: number;
  currency: string;
}

export interface CouponDepositDefaults {
  amount: number;
  transaction_date: string;
  currency: string;
  description: string;
  notes: string;
}

export function buildCouponDepositDefaults(
  bond: CouponDepositBond,
  couponDate: string
): CouponDepositDefaults {
  const description = `Coupon payment for bond ${bond.isin} and Issue ${bond.issue_number}`;
  return {
    amount: calculateCouponAmount(bond.coupon_rate, bond.face_value) ?? 0,
    transaction_date: couponDate,
    currency: bond.currency,
    description,
    notes: description,
  };
}
